import * as userCompanyApi from '../../api/userCompany'
import _ from 'lodash'

async function getUserCompanies({ commit }, getUserCompaniesData) {
  const userCompanies = await userCompanyApi.getUserCompanies(getUserCompaniesData)
  commit('setUserCompanies', userCompanies)
}

async function getUserCompany({ commit }, getUserCompanyData) {
  const userCompany = await userCompanyApi.getUserCompany(getUserCompanyData)
  commit('setSelectedUserCompany', userCompany)
}

async function createUserCompany({ dispatch }, createUserCompanyData) {
  await userCompanyApi.createUserCompany(createUserCompanyData)
  dispatch('getUserCompanies', {})
  //dispatch('notify', { newNotification: { type: 'success', message: 'Cég hozzárendelés létrehozva!' } })
}

// eslint-disable-next-line no-unused-vars
async function patchUserCompany({ dispatch }, patchUserCompanyData) {
  await userCompanyApi.patchUserCompany(patchUserCompanyData)
  //dispatch('notify', { newNotification: { type: 'success', message: 'Cég hozzárendelés frissítve.' } })
}

// eslint-disable-next-line no-unused-vars
async function deleteUserCompany({ dispatch }, deleteUserCompanyData) {
  await userCompanyApi.deleteUserCompany(deleteUserCompanyData)
  //dispatch('notify', { newNotification: { type: 'success', message: 'Cég hozzárendelés törölve!' } })
}

function setUserCompanies(state, userCompanies) {
  state.userCompanies = userCompanies
}

function setSelectedUserCompany(state, selectedUserCompany) {
  state.selectedUserCompany = selectedUserCompany
}

const userCompanyStore = {
  state: { userCompanies: [], selectedUserCompany: null },
  actions: {
    getUserCompanies,
    getUserCompany,
    createUserCompany,
    patchUserCompany,
    deleteUserCompany
  },
  mutations: {
    setUserCompanies,
    setSelectedUserCompany
  },
  getters: {
    userCompanyOptions: state => {
      const userCompanyOptions = state.userCompanies.map(userCompany => ({
        text: userCompany.companyData.short_name[0]?.name
          ? userCompany.companyData.short_name[0].name
          : userCompany.companyData.long_name[0].name,
        value: userCompany
      }))
      return userCompanyOptions
    },
    selectedUserCompany: state => {
      return state.selectedUserCompany
    },
    selectedUserCompanyApplications: state => {
      return _.sortBy(
        state.selectedUserCompany?.competitions.filter(competition => competition.type === 'APPLICATION'),
        a => a.name.toLowerCase()
      )
    },
    selectedUserCompanyCredits: state => {
      return _.sortBy(
        state.selectedUserCompany?.competitions.filter(competition => competition.type === 'CREDIT'),
        a => a.name.toLowerCase()
      )
    },
    selectedUserCompanyCapitalProducts: state => {
      return _.sortBy(
        state.selectedUserCompany?.competitions.filter(competition => competition.type === 'CAPITAL_PRODUCT'),
        a => a.name.toLowerCase()
      )
    },
    selectedUserCompanyGuarantees: state => {
      return _.sortBy(
        state.selectedUserCompany?.competitions.filter(competition => competition.type === 'GUARANTEE'),
        a => a.name.toLowerCase()
      )
    },
    userCompanies: state => {
      return state.userCompanies
    }
  }
}

export default userCompanyStore
